module.exports = __webpack_public_path__ + "static/homer541-5e064426e03eeb2c98eb4e399027d1a6.jpg";